import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {compose} from "recompose";

import moment from 'moment';

import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import FeedbackIcon from '@material-ui/icons/Feedback';
import ArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import ArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import red from '@material-ui/core/colors/red';
import yellow from '@material-ui/core/colors/yellow';
import {withStyles} from '@material-ui/core/styles';

import {DatePicker} from 'material-ui-pickers';

import {Line as LineChart, Doughnut as DoughnutChart} from 'react-chartjs-2';

import {fetchEmpresas} from '../actions/empresa';
import {fetchEventos} from '../actions/evento';

const styles = theme => ({
    filter: theme.mixins.gutters({
        paddingTop: 8,
        paddingBottom: 8,
        marginTop: theme.spacing.unit
    }),

    formControl: {
        marginRight: 24,
        minWidth: 120,
        display: 'flex'
    },

    selectEmpty: {
        marginRight: 24,
        marginTop: theme.spacing.unit * 2
    },

    gridRow: {
        height: 24
    },

    gridExpand: {
        width: 24,
        height: 24,
        padding: 0
    },

    gridEvents: {
        height: '100%',
        paddingTop: 0,
        paddingBottom: 0
    },

    gridActions: {
        textAlign: 'right',
        paddingTop: 0,
        paddingBottom: 0
    },

    dialogContent: {
        minWidth: 400
    }

});

class Dashboard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            empresa: '00000000000000',
            dateInitial: null,
            dateEnd: null,
            status: 'ERRO',
            dialogOpen: false,
            dialogMotivo: null,
            showCharts: true,
            eventos: [],

            lineDataChart: {
                datasets: [
                    {
                        label: 'Sucesso',
                        fill: false,
                        backgroundColor: '#51c05e',
                        borderColor: '#33c676',
                        pointBorderWidth: 5,
                        pointRadius: 1,
                        pointHitRadius: 10,
                        data: [],
                        spanGaps: true,
                    },
                    {
                        label: 'Erro',
                        fill: false,
                        backgroundColor: '#FF6384',
                        borderColor: '#F44336',
                        pointBorderWidth: 5,
                        pointRadius: 1,
                        pointHitRadius: 10,
                        data: [],
                        spanGaps: true,
                    },
                    {
                        label: 'Atenção',
                        fill: false,
                        backgroundColor: '#fffa7c',
                        borderColor: '#f4ef23',
                        pointBorderWidth: 5,
                        pointRadius: 1,
                        pointHitRadius: 10,
                        data: [],
                        spanGaps: true,
                    }
                ]
            },
            doughnutDataChart: {
                labels: ['Sucesso', 'Erro', 'Atenção'],
                datasets: [{
                    data: [0, 0],
                    backgroundColor: ['#51c05e', '#FF6384', '#fffa7c'],
                    hoverBackgroundColor: ['#51c05e', '#FF6384', '#f4ef23']
                }]
            }
        }
    }

    componentWillMount() {
        let end = moment().startOf('day');
        let start = moment().startOf('day').subtract(2, 'days');

        this.setState({dateEnd: end.toDate()});
        this.setState({dateInitial: start.toDate()});
    }

    componentDidMount() {
        this.props.getEmpresas();
        this.handleFilter();
    }

    componentWillReceiveProps(nextProps) {
        let eventos = nextProps.eventos;

        if (this.props.eventos !== nextProps.eventos && nextProps.eventos != null) {
            let eventosGroup = [...eventos.reverse()
                .filter((ele) => {
                    return this.state.status === 'TODOS' ? true : this.state.status === ele.tipo;
                })
                .reduce((row, ele) => {
                const key = ele.empresa.id;
                const item = row.get(key) || Object.assign({}, ele.empresa, {isExpandable: false}, {eventos: []});
                item.eventos.push({
                    id: ele.id,
                    data: ele.data,
                    tipo: ele.tipo,
                    observacao: ele.observacao
                });

                return row.set(key, item);
            }, new Map()).values()];

            this.setState({eventos: eventosGroup});
        }

        if (eventos) {
            let successEvents = eventos.filter((ele) => {
                return ele.tipo === 'SUCESSO';
            });

            let errorEvents = eventos.filter((ele) => {
                return ele.tipo === 'ERRO';
            });

            let warningEvents = eventos.filter((ele) => {
                return ele.tipo === 'ATENCAO';
            });

            let doughnutData = this.state.doughnutDataChart;
            doughnutData.datasets = [{
                labels: ['Sucesso', 'Erro', 'Atenção'],
                data: [successEvents.length, errorEvents.length, warningEvents.length],
                backgroundColor: ['#51c05e', '#FF6384', '#fffa7c'],
                hoverBackgroundColor: ['#51c05e', '#FF6384', '#fffa7c']
            }];

            this.setState({doughnutDataChart: doughnutData});

            let start = moment(this.state.dateInitial);
            let end = moment(this.state.dateEnd);
            let period = [];
            let periodSuccess = [];
            let periodError = [];
            let periodWarning = [];

            let index = 0;

            while (start <= end) {
                period.push(start.format('DD/MM/YYYY'));

                periodSuccess.push(0);
                periodError.push(0);
                periodWarning.push(0);

                for(let i = 0; i < successEvents.length; i++) {
                    if (moment(successEvents[i].data).isSame(start, 'day')) {
                        periodSuccess[index]++;
                    }
                }

                for(let i = 0; i < errorEvents.length; i++) {
                    if (moment(errorEvents[i].data).isSame(start, 'day')) {
                        periodError[index]++;
                    }
                }

                for(let i = 0; i < warningEvents.length; i++) {
                    if (moment(warningEvents[i].data).isSame(start, 'day')) {
                        periodWarning[index]++;
                    }
                }

                index++;
                start = start.add(1, 'days');
            }

            let lineData = this.state.lineDataChart;
            lineData.labels = period;
            lineData.datasets = [
                {
                    label: 'Sucesso',
                    fill: false,
                    backgroundColor: '#51c05e',
                    borderColor: '#33c676',
                    pointBorderWidth: 5,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: periodSuccess,
                    spanGaps: true,
                },
                {
                    label: 'Erro',
                    fill: false,
                    backgroundColor: '#FF6384',
                    borderColor: '#F44336',
                    pointBorderWidth: 5,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: periodError,
                    spanGaps: true,
                },
                {
                    label: 'Atenção',
                    fill: false,
                    backgroundColor: '#fffa7c',
                    borderColor: '#f4ef23',
                    pointBorderWidth: 5,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: periodWarning,
                    spanGaps: true,
                }
            ];

            this.setState({lineDataChart: lineData});
        }
    }

    handleStateEmpresa = (event) => {
        this.setState({empresa: event.target.value});
        this.handleFilter();
    };

    handleStateDateInitial(date) {
        this.setState({dateInitial: date});
        this.handleFilter();
    }

    handleStateDateEnd(date) {
        this.setState({dateEnd: date});
        this.handleFilter();
    }

    handleStateStatus(event) {
        this.setState({status: event.target.value});
        this.handleFilter();
    }

    handleFilter() {
        let start = moment(this.state.dateInitial).unix();
        let end = moment(this.state.dateEnd).unix();

        this.props.getEventos(this.state.empresa, start, end);
    }

    handleOpenDialog(motivo) {
        this.setState({dialogOpen: true});
        this.setState({dialogMotivo: motivo});
    }

    handleCloseDialog() {
        this.setState({dialogOpen: false});
    }

    handleCollapse(row, index) {
        let empresa = this.state.eventos[index];
        empresa.isExpandable = !row.isExpandable;

        let arr = this.state.eventos;
        arr[index] = empresa;

        this.setState({eventos: arr});
    }

    formatDateTime(dateTime) {
        return moment(dateTime).format('DD/MM/YYYY HH:mm:ss');
    }

    formatRow(tipo) {
        switch (tipo) {
            case 'ERRO':
                return red[500];
            case 'ATENCAO':
                return yellow[500];
            default:
                return null;
        } 
    }

    createMarkup() {
        return {__html: this.state.dialogMotivo};
    }

    render() {
        return (
            <Fragment>
                <Grid container spacing={8}>
                    <Grid item sm={12} md={2}>
                        <FormControl className={this.props.classes.formControl}>
                            <InputLabel htmlFor="empresa">Empresa</InputLabel>
                            <Select value={this.state.empresa} onChange={this.handleStateEmpresa}
                                    input={<Input name="empresa" />} className={this.props.selectEmpty}>
                                <MenuItem value="00000000000000">TODAS</MenuItem>
                                {this.props.empresas && this.props.empresas.map(row => (
                                    <MenuItem key={row.id} value={row.cnpj}>{row.nome}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item sm={3} md={2}>
                        <FormControl className={this.props.classes.formControl}>
                            <DatePicker label="Período Inicial" format="DD/MM/YYYY"
                                        value={this.state.dateInitial} onChange={this.handleStateDateInitial.bind(this)}/>
                        </FormControl>
                    </Grid>
                    <Grid item sm={3} md={2}>
                        <FormControl className={this.props.classes.formControl}>
                            <DatePicker label="Período Final" format="DD/MM/YYYY"
                                        value={this.state.dateEnd} onChange={this.handleStateDateEnd.bind(this)}/>
                        </FormControl>
                    </Grid>
                    <Grid item sm={3} md={2}>
                        <FormControl className={this.props.classes.formControl}>
                            <InputLabel htmlFor="empresa">Status</InputLabel>
                            <Select value={this.state.status} onChange={this.handleStateStatus.bind(this)}
                                    input={<Input name="status" />} className={this.props.selectEmpty}>
                                <MenuItem value="TODOS">TODOS</MenuItem>
                                <MenuItem value="SUCESSO">SUCESSO</MenuItem>
                                <MenuItem value="ERRO">ERRO</MenuItem>
                                <MenuItem value="ATENCAO">ATENÇÃO</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item sm={3} md={2}>
                        <FormControlLabel control={
                            <Switch checked={this.state.showCharts} onChange={(event, checked) => this.setState({showCharts: checked})}/>
                        } label="Gráficos"/>
                    </Grid>
                </Grid>

                <Collapse in={this.state.showCharts}>
                    <Grid container spacing={8}>
                        <Grid item sm={12} md={8}>
                            <LineChart data={this.state.lineDataChart} height={75}/>
                        </Grid>
                        <Grid item sm={12} md={4}>
                            <DoughnutChart data={this.state.doughnutDataChart} height={150}/>
                        </Grid>
                    </Grid>
                </Collapse>

                <Grid container spacing={8}>
                    <Grid item xs={12}>
                        <Table className={'table-eventos'}>
                            <TableHead>
                                <TableRow className={this.props.classes.gridRow}>
                                    <TableCell style={{padding: 0}}/>
                                    <TableCell>Empresa</TableCell>
                                </TableRow>
                            </TableHead>
                            {this.state.eventos ?
                                <TableBody>
                                    {this.state.eventos.map((row, index) => (
                                        <Fragment key={row.id}>
                                            <TableRow className={this.props.classes.gridRow}>
                                                <TableCell className={this.props.classes.gridExpand}>
                                                    {row.eventos.length > 0 ?
                                                        <IconButton onClick={() => this.handleCollapse(row, index)}>
                                                            {row.isExpandable ? <ArrowUpIcon/> : <ArrowDownIcon/>}
                                                        </IconButton>
                                                        : null
                                                    }
                                                </TableCell>
                                                <TableCell>{row.nome}</TableCell>
                                            </TableRow>
                                            {row.isExpandable ?
                                                <TableRow>
                                                    <TableCell className={this.props.classes.gridExpand}/>
                                                    <TableCell className={this.props.classes.gridEvents}>
                                                        <Table>
                                                            <TableBody>
                                                                {row.eventos.map((evento) => (
                                                                    <TableRow key={evento.id} className={this.props.classes.gridRow} style={{backgroundColor: this.formatRow(evento.tipo)}}>
                                                                        <TableCell>{this.formatDateTime(evento.data)}</TableCell>
                                                                        <TableCell>{evento.tipo}</TableCell>
                                                                        <TableCell className={this.props.classes.gridActions}>
                                                                            <IconButton onClick={() => this.handleOpenDialog(evento.observacao)}
                                                                                        className={this.props.classes.gridRow}
                                                                                        disabled={evento.observacao === null || evento.observacao === undefined}>
                                                                                <FeedbackIcon/>
                                                                            </IconButton>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                    )
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableCell>
                                                </TableRow>
                                            : null}
                                        </Fragment>
                                        )
                                    )}
                                </TableBody>
                                : null
                            }
                        </Table>
                    </Grid>
                </Grid>

                <Dialog disableBackdropClick disableEscapeKeyDown open={this.state.dialogOpen} aria-labelledby="motivo-dialog-title">
                    <DialogTitle id="motivo-dialog-title">Motivo</DialogTitle>
                    <DialogContent className={this.props.classes.dialogContent}>
                        <div dangerouslySetInnerHTML={this.createMarkup()}/>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" autoFocus onClick={this.handleCloseDialog.bind(this)}>Fechar</Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        eventos: state.eventos.data,
        empresas: state.empresas.data
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getEventos: (cnpj, start, end) => dispatch(fetchEventos(cnpj, start, end)),
        getEmpresas: () => dispatch(fetchEmpresas())
    };
};

export default compose(
    withStyles(styles, {name: 'Dashboard'}),
    connect(mapStateToProps, mapDispatchToProps)
)(Dashboard);


// WEBPACK FOOTER //
// src/components/Dashboard.js